import React, {MutableRefObject} from "react";
import {loadStripe} from '@stripe/stripe-js';
import {Elements} from '@stripe/react-stripe-js';
import PropTypes from "prop-types";
import {
    ReservationPaymentWrapper,
    SecureWrapper,
    StripeWrapper,
    Title,
} from "./styles";
import {formRules} from '../style';
import {useTranslation} from "react-i18next";
import i18n from "../../../../i18n";
import {useSelector} from "react-redux";
import {selectPayment} from "../../../../store/slices/reservation/selectors";
import {CheckoutForm} from "../CheckoutForm";
import {ReservationRoutes as Routes} from "../../routes";
import lock from '../../../../assets/images/reservation/ic_lock.svg';
import cards from '../../../../assets/images/reservation/cards.svg';

const apiKey = process.env.REACT_APP_STRIPE_API_KEY;
const stripePromise = loadStripe(`${apiKey}` || '');

const stripeElementsOptions = clientSecret => ({
    fonts: [ { cssSrc: 'https://fonts.googleapis.com/css?family=Lato:300,300i,400,500,600' } ],
    locale: i18n.language || 'en',
    clientSecret,
    appearance: {
        theme: "none",
        rules: formRules
    }
});

const ReservationPayment = props => {
    const {submitRef} = props;
    const {t} = useTranslation();
    const payment = useSelector(selectPayment);

    if(!payment?.stripe_client_secret) {
        return null;
    }

    return (<ReservationPaymentWrapper>
        <Title>{t('ADD_PAYMENT_DETAILS')}</Title>
        <StripeWrapper>
            {
                !window.location.pathname.endsWith(`${Routes.Finished}`) && !window.location.hash.endsWith(`${Routes.Finished}`) &&
                <Elements
                        key={payment?.stripe_client_secret} // <-- Add a unique key to force re-render when payment changes
                        options={stripeElementsOptions(payment?.stripe_client_secret)}
                        stripe={stripePromise}
                    >
                        <CheckoutForm submitRef={submitRef} />
                    </Elements>
            }
        </StripeWrapper>
        <SecureWrapper>
            <img src={lock} alt="lock" />
            <span>{t('GUARANTEED_SAFE_AND_SECURE')}</span>
            <img src={cards} alt="cards"/>
        </SecureWrapper>
    </ReservationPaymentWrapper>)
}

ReservationPayment.propTypes = {
    submitRef: PropTypes.object
}

export default ReservationPayment;
